import { useContext } from 'react'
import { AuthContext } from '@/auth/auth-context'
import type { AuthContextValue } from '@/auth/auth-context'
import type { AdminUser } from '@/types/admin'

export function useAuth(): AuthContextValue {
  const context = useContext(AuthContext)
  if (!context) {
    throw new Error('useAuth must be used inside <AuthProvider>')
  }
  return context
}

/**
 * For screens rendered under RequireAuth, where a user is guaranteed. Throws rather
 * than returning null so callers never need a `user?.` chain that hides a real bug.
 */
export function useCurrentUser(): AdminUser {
  const { user } = useAuth()
  if (!user) {
    throw new Error('useCurrentUser was called outside an authenticated route')
  }
  return user
}
